package flagpack.icons.small

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Cayman Islands Flag (16x12dp)
 *
 * - ISO Alpha-2: KY
 * - ISO Alpha-3: CYM
 * - ISO Numeric: 136
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Small.CaymanIslands: ImageVector by lazy {
    ImageVector.Builder(
        name = "Cayman Islands:KY:CYM:136:Small",
        defaultWidth = 16.dp,
        defaultHeight = 12.dp,
        viewportWidth = 16f,
        viewportHeight = 12f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFF2E42A5)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                horizontalLineTo(16f)
                verticalLineTo(12f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(11.284f, 6.356f)
                horizontalLineToRelative(4f)
                verticalLineToRelative(4f)
                horizontalLineToRelative(-4f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color.White),
                stroke = SolidColor(Color(0xFFF7FCFF)),
                strokeLineWidth = 0.25f
            ) {
                moveTo(11.287f, 6.231f)
                horizontalLineTo(11.162f)
                verticalLineTo(6.356f)
                verticalLineTo(7.845f)
                curveTo(11.162f, 8.831f, 11.575f, 9.49f, 11.998f, 9.9f)
                curveTo(12.208f, 10.105f, 12.42f, 10.247f, 12.584f, 10.339f)
                curveTo(12.665f, 10.385f, 12.736f, 10.419f, 12.789f, 10.441f)
                curveTo(12.815f, 10.452f, 12.838f, 10.461f, 12.856f, 10.467f)
                curveTo(12.865f, 10.47f, 12.874f, 10.473f, 12.883f, 10.475f)
                lineTo(12.883f, 10.476f)
                curveTo(12.888f, 10.477f, 12.905f, 10.481f, 12.924f, 10.481f)
                curveTo(12.944f, 10.481f, 12.961f, 10.477f, 12.966f, 10.475f)
                lineTo(12.967f, 10.475f)
                curveTo(12.975f, 10.473f, 12.984f, 10.47f, 12.993f, 10.467f)
                curveTo(13.011f, 10.46f, 13.033f, 10.451f, 13.058f, 10.44f)
                curveTo(13.109f, 10.417f, 13.175f, 10.384f, 13.252f, 10.337f)
                curveTo(13.406f, 10.245f, 13.604f, 10.102f, 13.799f, 9.897f)
                curveTo(14.192f, 9.485f, 14.573f, 8.828f, 14.573f, 7.845f)
                verticalLineTo(7.843f)
                verticalLineTo(7.841f)
                verticalLineTo(7.839f)
                verticalLineTo(7.837f)
                verticalLineTo(7.835f)
                verticalLineTo(7.833f)
                verticalLineTo(7.831f)
                verticalLineTo(7.828f)
                verticalLineTo(7.826f)
                verticalLineTo(7.824f)
                verticalLineTo(7.822f)
                verticalLineTo(7.82f)
                verticalLineTo(7.818f)
                verticalLineTo(7.816f)
                verticalLineTo(7.813f)
                verticalLineTo(7.811f)
                verticalLineTo(7.809f)
                verticalLineTo(7.807f)
                verticalLineTo(7.805f)
                verticalLineTo(7.802f)
                verticalLineTo(7.8f)
                verticalLineTo(7.798f)
                verticalLineTo(7.796f)
                verticalLineTo(7.793f)
                verticalLineTo(7.791f)
                verticalLineTo(7.789f)
                verticalLineTo(7.787f)
                verticalLineTo(7.784f)
                verticalLineTo(7.782f)
                verticalLineTo(7.78f)
                verticalLineTo(7.778f)
                verticalLineTo(7.775f)
                verticalLineTo(7.773f)
                verticalLineTo(7.771f)
                verticalLineTo(7.768f)
                verticalLineTo(7.766f)
                verticalLineTo(7.764f)
                verticalLineTo(7.761f)
                verticalLineTo(7.759f)
                verticalLineTo(7.757f)
                verticalLineTo(7.754f)
                verticalLineTo(7.752f)
                verticalLineTo(7.749f)
                verticalLineTo(7.747f)
                verticalLineTo(7.745f)
                verticalLineTo(7.742f)
                verticalLineTo(7.74f)
                verticalLineTo(7.737f)
                verticalLineTo(7.735f)
                verticalLineTo(7.733f)
                verticalLineTo(7.73f)
                verticalLineTo(7.728f)
                verticalLineTo(7.725f)
                verticalLineTo(7.723f)
                verticalLineTo(7.72f)
                verticalLineTo(7.718f)
                verticalLineTo(7.715f)
                verticalLineTo(7.713f)
                verticalLineTo(7.71f)
                verticalLineTo(7.708f)
                verticalLineTo(7.705f)
                verticalLineTo(7.703f)
                verticalLineTo(7.7f)
                verticalLineTo(7.698f)
                verticalLineTo(7.695f)
                verticalLineTo(7.693f)
                verticalLineTo(7.69f)
                verticalLineTo(7.688f)
                verticalLineTo(7.685f)
                verticalLineTo(7.682f)
                verticalLineTo(7.68f)
                verticalLineTo(7.677f)
                verticalLineTo(7.675f)
                verticalLineTo(7.672f)
                verticalLineTo(7.67f)
                verticalLineTo(7.667f)
                verticalLineTo(7.664f)
                verticalLineTo(7.662f)
                verticalLineTo(7.659f)
                verticalLineTo(7.657f)
                verticalLineTo(7.654f)
                verticalLineTo(7.651f)
                verticalLineTo(7.649f)
                verticalLineTo(7.646f)
                verticalLineTo(7.643f)
                verticalLineTo(7.641f)
                verticalLineTo(7.638f)
                verticalLineTo(7.635f)
                verticalLineTo(7.633f)
                verticalLineTo(7.63f)
                verticalLineTo(7.627f)
                verticalLineTo(7.625f)
                verticalLineTo(7.622f)
                verticalLineTo(7.619f)
                verticalLineTo(7.616f)
                verticalLineTo(7.614f)
                verticalLineTo(7.611f)
                verticalLineTo(7.608f)
                verticalLineTo(7.606f)
                verticalLineTo(7.603f)
                verticalLineTo(7.6f)
                verticalLineTo(7.597f)
                verticalLineTo(7.595f)
                verticalLineTo(7.592f)
                verticalLineTo(7.589f)
                verticalLineTo(7.586f)
                verticalLineTo(7.584f)
                verticalLineTo(7.581f)
                verticalLineTo(7.578f)
                verticalLineTo(7.575f)
                verticalLineTo(7.572f)
                verticalLineTo(7.57f)
                verticalLineTo(7.567f)
                verticalLineTo(7.564f)
                verticalLineTo(7.561f)
                verticalLineTo(7.558f)
                verticalLineTo(7.556f)
                verticalLineTo(7.553f)
                verticalLineTo(7.55f)
                verticalLineTo(7.547f)
                verticalLineTo(7.544f)
                verticalLineTo(7.541f)
                verticalLineTo(7.538f)
                verticalLineTo(7.536f)
                verticalLineTo(7.533f)
                verticalLineTo(7.53f)
                verticalLineTo(7.527f)
                verticalLineTo(7.524f)
                verticalLineTo(7.521f)
                verticalLineTo(7.518f)
                verticalLineTo(7.515f)
                verticalLineTo(7.513f)
                verticalLineTo(7.51f)
                verticalLineTo(7.507f)
                verticalLineTo(7.504f)
                verticalLineTo(7.501f)
                verticalLineTo(7.498f)
                verticalLineTo(7.495f)
                verticalLineTo(7.492f)
                verticalLineTo(7.489f)
                verticalLineTo(7.486f)
                verticalLineTo(7.483f)
                verticalLineTo(7.48f)
                verticalLineTo(7.478f)
                verticalLineTo(7.475f)
                verticalLineTo(7.472f)
                verticalLineTo(7.469f)
                verticalLineTo(7.466f)
                verticalLineTo(7.463f)
                verticalLineTo(7.46f)
                verticalLineTo(7.457f)
                verticalLineTo(7.454f)
                verticalLineTo(7.451f)
                verticalLineTo(7.448f)
                verticalLineTo(7.445f)
                verticalLineTo(7.442f)
                verticalLineTo(7.439f)
                verticalLineTo(7.436f)
                verticalLineTo(7.433f)
                verticalLineTo(7.43f)
                verticalLineTo(7.427f)
                verticalLineTo(7.424f)
                verticalLineTo(7.421f)
                verticalLineTo(7.418f)
                verticalLineTo(7.415f)
                verticalLineTo(7.412f)
                verticalLineTo(7.409f)
                verticalLineTo(7.406f)
                verticalLineTo(7.403f)
                verticalLineTo(7.4f)
                verticalLineTo(7.397f)
                verticalLineTo(7.393f)
                verticalLineTo(7.39f)
                verticalLineTo(7.387f)
                verticalLineTo(7.384f)
                verticalLineTo(7.381f)
                verticalLineTo(7.378f)
                verticalLineTo(7.375f)
                verticalLineTo(7.372f)
                verticalLineTo(7.369f)
                verticalLineTo(7.366f)
                verticalLineTo(7.363f)
                verticalLineTo(7.36f)
                verticalLineTo(7.357f)
                verticalLineTo(7.354f)
                verticalLineTo(7.35f)
                verticalLineTo(7.347f)
                verticalLineTo(7.344f)
                verticalLineTo(7.341f)
                verticalLineTo(7.338f)
                verticalLineTo(7.335f)
                verticalLineTo(7.332f)
                verticalLineTo(7.329f)
                verticalLineTo(7.326f)
                verticalLineTo(7.323f)
                verticalLineTo(7.319f)
                verticalLineTo(7.316f)
                verticalLineTo(7.313f)
                verticalLineTo(7.31f)
                verticalLineTo(7.307f)
                verticalLineTo(7.304f)
                verticalLineTo(7.301f)
                verticalLineTo(7.298f)
                verticalLineTo(7.294f)
                verticalLineTo(7.291f)
                verticalLineTo(7.288f)
                verticalLineTo(7.285f)
                verticalLineTo(7.282f)
                verticalLineTo(7.279f)
                verticalLineTo(7.275f)
                verticalLineTo(7.272f)
                verticalLineTo(7.269f)
                verticalLineTo(7.266f)
                verticalLineTo(7.263f)
                verticalLineTo(7.26f)
                verticalLineTo(7.257f)
                verticalLineTo(7.253f)
                verticalLineTo(7.25f)
                verticalLineTo(7.247f)
                verticalLineTo(7.244f)
                verticalLineTo(7.241f)
                verticalLineTo(7.237f)
                verticalLineTo(7.234f)
                verticalLineTo(7.231f)
                verticalLineTo(7.228f)
                verticalLineTo(7.225f)
                verticalLineTo(7.222f)
                verticalLineTo(7.218f)
                verticalLineTo(7.215f)
                verticalLineTo(7.212f)
                verticalLineTo(7.209f)
                verticalLineTo(7.206f)
                verticalLineTo(7.202f)
                verticalLineTo(7.199f)
                verticalLineTo(7.196f)
                verticalLineTo(7.193f)
                verticalLineTo(7.19f)
                verticalLineTo(7.186f)
                verticalLineTo(7.183f)
                verticalLineTo(7.18f)
                verticalLineTo(7.177f)
                verticalLineTo(7.174f)
                verticalLineTo(7.17f)
                verticalLineTo(7.167f)
                verticalLineTo(7.164f)
                verticalLineTo(7.161f)
                verticalLineTo(7.158f)
                verticalLineTo(7.154f)
                verticalLineTo(7.151f)
                verticalLineTo(7.148f)
                verticalLineTo(7.145f)
                verticalLineTo(7.141f)
                verticalLineTo(7.138f)
                verticalLineTo(7.135f)
                verticalLineTo(7.132f)
                verticalLineTo(7.129f)
                verticalLineTo(7.125f)
                verticalLineTo(7.122f)
                verticalLineTo(7.119f)
                verticalLineTo(7.116f)
                verticalLineTo(7.112f)
                verticalLineTo(7.109f)
                verticalLineTo(7.106f)
                verticalLineTo(7.103f)
                verticalLineTo(7.1f)
                verticalLineTo(7.096f)
                verticalLineTo(7.093f)
                verticalLineTo(7.09f)
                verticalLineTo(7.087f)
                verticalLineTo(7.083f)
                verticalLineTo(7.08f)
                verticalLineTo(7.077f)
                verticalLineTo(7.074f)
                verticalLineTo(7.07f)
                verticalLineTo(7.067f)
                verticalLineTo(7.064f)
                verticalLineTo(7.061f)
                verticalLineTo(7.057f)
                verticalLineTo(7.054f)
                verticalLineTo(7.051f)
                verticalLineTo(7.048f)
                verticalLineTo(7.045f)
                verticalLineTo(7.041f)
                verticalLineTo(7.038f)
                verticalLineTo(7.035f)
                verticalLineTo(7.032f)
                verticalLineTo(7.028f)
                verticalLineTo(7.025f)
                verticalLineTo(7.022f)
                verticalLineTo(7.019f)
                verticalLineTo(7.015f)
                verticalLineTo(7.012f)
                verticalLineTo(7.009f)
                verticalLineTo(7.006f)
                verticalLineTo(7.002f)
                verticalLineTo(6.999f)
                verticalLineTo(6.996f)
                verticalLineTo(6.993f)
                verticalLineTo(6.99f)
                verticalLineTo(6.986f)
                verticalLineTo(6.983f)
                verticalLineTo(6.98f)
                verticalLineTo(6.977f)
                verticalLineTo(6.973f)
                verticalLineTo(6.97f)
                verticalLineTo(6.967f)
                verticalLineTo(6.964f)
                verticalLineTo(6.96f)
                verticalLineTo(6.957f)
                verticalLineTo(6.954f)
                verticalLineTo(6.951f)
                verticalLineTo(6.948f)
                verticalLineTo(6.944f)
                verticalLineTo(6.941f)
                verticalLineTo(6.938f)
                verticalLineTo(6.935f)
                verticalLineTo(6.931f)
                verticalLineTo(6.928f)
                verticalLineTo(6.925f)
                verticalLineTo(6.922f)
                verticalLineTo(6.919f)
                verticalLineTo(6.915f)
                verticalLineTo(6.912f)
                verticalLineTo(6.909f)
                verticalLineTo(6.906f)
                verticalLineTo(6.902f)
                verticalLineTo(6.899f)
                verticalLineTo(6.896f)
                verticalLineTo(6.893f)
                verticalLineTo(6.89f)
                verticalLineTo(6.886f)
                verticalLineTo(6.883f)
                verticalLineTo(6.88f)
                verticalLineTo(6.877f)
                verticalLineTo(6.874f)
                verticalLineTo(6.87f)
                verticalLineTo(6.867f)
                verticalLineTo(6.864f)
                verticalLineTo(6.861f)
                verticalLineTo(6.858f)
                verticalLineTo(6.854f)
                verticalLineTo(6.851f)
                verticalLineTo(6.848f)
                verticalLineTo(6.845f)
                verticalLineTo(6.842f)
                verticalLineTo(6.839f)
                verticalLineTo(6.835f)
                verticalLineTo(6.832f)
                verticalLineTo(6.829f)
                verticalLineTo(6.826f)
                verticalLineTo(6.823f)
                verticalLineTo(6.819f)
                verticalLineTo(6.816f)
                verticalLineTo(6.813f)
                verticalLineTo(6.81f)
                verticalLineTo(6.807f)
                verticalLineTo(6.804f)
                verticalLineTo(6.8f)
                verticalLineTo(6.797f)
                verticalLineTo(6.794f)
                verticalLineTo(6.791f)
                verticalLineTo(6.788f)
                verticalLineTo(6.785f)
                verticalLineTo(6.782f)
                verticalLineTo(6.778f)
                verticalLineTo(6.775f)
                verticalLineTo(6.772f)
                verticalLineTo(6.769f)
                verticalLineTo(6.766f)
                verticalLineTo(6.763f)
                verticalLineTo(6.76f)
                verticalLineTo(6.756f)
                verticalLineTo(6.753f)
                verticalLineTo(6.75f)
                verticalLineTo(6.747f)
                verticalLineTo(6.744f)
                verticalLineTo(6.741f)
                verticalLineTo(6.738f)
                verticalLineTo(6.735f)
                verticalLineTo(6.731f)
                verticalLineTo(6.728f)
                verticalLineTo(6.725f)
                verticalLineTo(6.722f)
                verticalLineTo(6.719f)
                verticalLineTo(6.716f)
                verticalLineTo(6.713f)
                verticalLineTo(6.71f)
                verticalLineTo(6.707f)
                verticalLineTo(6.704f)
                verticalLineTo(6.701f)
                verticalLineTo(6.697f)
                verticalLineTo(6.694f)
                verticalLineTo(6.691f)
                verticalLineTo(6.688f)
                verticalLineTo(6.685f)
                verticalLineTo(6.682f)
                verticalLineTo(6.679f)
                verticalLineTo(6.676f)
                verticalLineTo(6.673f)
                verticalLineTo(6.67f)
                verticalLineTo(6.667f)
                verticalLineTo(6.664f)
                verticalLineTo(6.661f)
                verticalLineTo(6.658f)
                verticalLineTo(6.655f)
                verticalLineTo(6.652f)
                verticalLineTo(6.649f)
                verticalLineTo(6.646f)
                verticalLineTo(6.643f)
                verticalLineTo(6.64f)
                verticalLineTo(6.637f)
                verticalLineTo(6.634f)
                verticalLineTo(6.631f)
                verticalLineTo(6.628f)
                verticalLineTo(6.625f)
                verticalLineTo(6.622f)
                verticalLineTo(6.619f)
                verticalLineTo(6.616f)
                verticalLineTo(6.613f)
                verticalLineTo(6.61f)
                verticalLineTo(6.607f)
                verticalLineTo(6.604f)
                verticalLineTo(6.601f)
                verticalLineTo(6.598f)
                verticalLineTo(6.595f)
                verticalLineTo(6.592f)
                verticalLineTo(6.589f)
                verticalLineTo(6.586f)
                verticalLineTo(6.583f)
                verticalLineTo(6.58f)
                verticalLineTo(6.577f)
                verticalLineTo(6.574f)
                verticalLineTo(6.571f)
                verticalLineTo(6.568f)
                verticalLineTo(6.566f)
                verticalLineTo(6.563f)
                verticalLineTo(6.56f)
                verticalLineTo(6.557f)
                verticalLineTo(6.554f)
                verticalLineTo(6.551f)
                verticalLineTo(6.548f)
                verticalLineTo(6.545f)
                verticalLineTo(6.542f)
                verticalLineTo(6.54f)
                verticalLineTo(6.537f)
                verticalLineTo(6.534f)
                verticalLineTo(6.531f)
                verticalLineTo(6.528f)
                verticalLineTo(6.525f)
                verticalLineTo(6.522f)
                verticalLineTo(6.52f)
                verticalLineTo(6.517f)
                verticalLineTo(6.514f)
                verticalLineTo(6.511f)
                verticalLineTo(6.508f)
                verticalLineTo(6.505f)
                verticalLineTo(6.503f)
                verticalLineTo(6.5f)
                verticalLineTo(6.497f)
                verticalLineTo(6.494f)
                verticalLineTo(6.491f)
                verticalLineTo(6.489f)
                verticalLineTo(6.486f)
                verticalLineTo(6.483f)
                verticalLineTo(6.48f)
                verticalLineTo(6.478f)
                verticalLineTo(6.475f)
                verticalLineTo(6.472f)
                verticalLineTo(6.469f)
                verticalLineTo(6.467f)
                verticalLineTo(6.464f)
                verticalLineTo(6.461f)
                verticalLineTo(6.458f)
                verticalLineTo(6.456f)
                verticalLineTo(6.453f)
                verticalLineTo(6.45f)
                verticalLineTo(6.447f)
                verticalLineTo(6.445f)
                verticalLineTo(6.442f)
                verticalLineTo(6.439f)
                verticalLineTo(6.437f)
                verticalLineTo(6.434f)
                verticalLineTo(6.431f)
                verticalLineTo(6.429f)
                verticalLineTo(6.426f)
                verticalLineTo(6.423f)
                verticalLineTo(6.421f)
                verticalLineTo(6.418f)
                verticalLineTo(6.415f)
                verticalLineTo(6.413f)
                verticalLineTo(6.41f)
                verticalLineTo(6.408f)
                verticalLineTo(6.405f)
                verticalLineTo(6.402f)
                verticalLineTo(6.4f)
                verticalLineTo(6.397f)
                verticalLineTo(6.394f)
                verticalLineTo(6.392f)
                verticalLineTo(6.389f)
                verticalLineTo(6.387f)
                verticalLineTo(6.384f)
                verticalLineTo(6.382f)
                verticalLineTo(6.379f)
                verticalLineTo(6.377f)
                verticalLineTo(6.374f)
                verticalLineTo(6.371f)
                verticalLineTo(6.369f)
                verticalLineTo(6.366f)
                verticalLineTo(6.364f)
                verticalLineTo(6.361f)
                verticalLineTo(6.359f)
                verticalLineTo(6.356f)
                verticalLineTo(6.231f)
                horizontalLineTo(14.448f)
                horizontalLineTo(11.287f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(11.287f, 6.231f)
                horizontalLineTo(11.162f)
                verticalLineTo(6.356f)
                verticalLineTo(7.845f)
                curveTo(11.162f, 8.831f, 11.575f, 9.49f, 11.998f, 9.9f)
                curveTo(12.208f, 10.105f, 12.42f, 10.247f, 12.584f, 10.339f)
                curveTo(12.665f, 10.385f, 12.736f, 10.419f, 12.789f, 10.441f)
                curveTo(12.815f, 10.452f, 12.838f, 10.461f, 12.856f, 10.467f)
                curveTo(12.865f, 10.47f, 12.874f, 10.473f, 12.883f, 10.475f)
                lineTo(12.883f, 10.476f)
                curveTo(12.888f, 10.477f, 12.905f, 10.481f, 12.924f, 10.481f)
                curveTo(12.944f, 10.481f, 12.961f, 10.477f, 12.966f, 10.475f)
                lineTo(12.967f, 10.475f)
                curveTo(12.975f, 10.473f, 12.984f, 10.47f, 12.993f, 10.467f)
                curveTo(13.011f, 10.46f, 13.033f, 10.451f, 13.058f, 10.44f)
                curveTo(13.109f, 10.417f, 13.175f, 10.384f, 13.252f, 10.337f)
                curveTo(13.406f, 10.245f, 13.604f, 10.102f, 13.799f, 9.897f)
                curveTo(14.192f, 9.485f, 14.573f, 8.828f, 14.573f, 7.845f)
                verticalLineTo(7.843f)
                verticalLineTo(7.841f)
                verticalLineTo(7.839f)
                verticalLineTo(7.837f)
                verticalLineTo(7.835f)
                verticalLineTo(7.833f)
                verticalLineTo(7.831f)
                verticalLineTo(7.828f)
                verticalLineTo(7.826f)
                verticalLineTo(7.824f)
                verticalLineTo(7.822f)
                verticalLineTo(7.82f)
                verticalLineTo(7.818f)
                verticalLineTo(7.816f)
                verticalLineTo(7.813f)
                verticalLineTo(7.811f)
                verticalLineTo(7.809f)
                verticalLineTo(7.807f)
                verticalLineTo(7.805f)
                verticalLineTo(7.802f)
                verticalLineTo(7.8f)
                verticalLineTo(7.798f)
                verticalLineTo(7.796f)
                verticalLineTo(7.793f)
                verticalLineTo(7.791f)
                verticalLineTo(7.789f)
                verticalLineTo(7.787f)
                verticalLineTo(7.784f)
                verticalLineTo(7.782f)
                verticalLineTo(7.78f)
                verticalLineTo(7.778f)
                verticalLineTo(7.775f)
                verticalLineTo(7.773f)
                verticalLineTo(7.771f)
                verticalLineTo(7.768f)
                verticalLineTo(7.766f)
                verticalLineTo(7.764f)
                verticalLineTo(7.761f)
                verticalLineTo(7.759f)
                verticalLineTo(7.757f)
                verticalLineTo(7.754f)
                verticalLineTo(7.752f)
                verticalLineTo(7.749f)
                verticalLineTo(7.747f)
                verticalLineTo(7.745f)
                verticalLineTo(7.742f)
                verticalLineTo(7.74f)
                verticalLineTo(7.737f)
                verticalLineTo(7.735f)
                verticalLineTo(7.733f)
                verticalLineTo(7.73f)
                verticalLineTo(7.728f)
                verticalLineTo(7.725f)
                verticalLineTo(7.723f)
                verticalLineTo(7.72f)
                verticalLineTo(7.718f)
                verticalLineTo(7.715f)
                verticalLineTo(7.713f)
                verticalLineTo(7.71f)
                verticalLineTo(7.708f)
                verticalLineTo(7.705f)
                verticalLineTo(7.703f)
                verticalLineTo(7.7f)
                verticalLineTo(7.698f)
                verticalLineTo(7.695f)
                verticalLineTo(7.693f)
                verticalLineTo(7.69f)
                verticalLineTo(7.688f)
                verticalLineTo(7.685f)
                verticalLineTo(7.682f)
                verticalLineTo(7.68f)
                verticalLineTo(7.677f)
                verticalLineTo(7.675f)
                verticalLineTo(7.672f)
                verticalLineTo(7.67f)
                verticalLineTo(7.667f)
                verticalLineTo(7.664f)
                verticalLineTo(7.662f)
                verticalLineTo(7.659f)
                verticalLineTo(7.657f)
                verticalLineTo(7.654f)
                verticalLineTo(7.651f)
                verticalLineTo(7.649f)
                verticalLineTo(7.646f)
                verticalLineTo(7.643f)
                verticalLineTo(7.641f)
                verticalLineTo(7.638f)
                verticalLineTo(7.635f)
                verticalLineTo(7.633f)
                verticalLineTo(7.63f)
                verticalLineTo(7.627f)
                verticalLineTo(7.625f)
                verticalLineTo(7.622f)
                verticalLineTo(7.619f)
                verticalLineTo(7.616f)
                verticalLineTo(7.614f)
                verticalLineTo(7.611f)
                verticalLineTo(7.608f)
                verticalLineTo(7.606f)
                verticalLineTo(7.603f)
                verticalLineTo(7.6f)
                verticalLineTo(7.597f)
                verticalLineTo(7.595f)
                verticalLineTo(7.592f)
                verticalLineTo(7.589f)
                verticalLineTo(7.586f)
                verticalLineTo(7.584f)
                verticalLineTo(7.581f)
                verticalLineTo(7.578f)
                verticalLineTo(7.575f)
                verticalLineTo(7.572f)
                verticalLineTo(7.57f)
                verticalLineTo(7.567f)
                verticalLineTo(7.564f)
                verticalLineTo(7.561f)
                verticalLineTo(7.558f)
                verticalLineTo(7.556f)
                verticalLineTo(7.553f)
                verticalLineTo(7.55f)
                verticalLineTo(7.547f)
                verticalLineTo(7.544f)
                verticalLineTo(7.541f)
                verticalLineTo(7.538f)
                verticalLineTo(7.536f)
                verticalLineTo(7.533f)
                verticalLineTo(7.53f)
                verticalLineTo(7.527f)
                verticalLineTo(7.524f)
                verticalLineTo(7.521f)
                verticalLineTo(7.518f)
                verticalLineTo(7.515f)
                verticalLineTo(7.513f)
                verticalLineTo(7.51f)
                verticalLineTo(7.507f)
                verticalLineTo(7.504f)
                verticalLineTo(7.501f)
                verticalLineTo(7.498f)
                verticalLineTo(7.495f)
                verticalLineTo(7.492f)
                verticalLineTo(7.489f)
                verticalLineTo(7.486f)
                verticalLineTo(7.483f)
                verticalLineTo(7.48f)
                verticalLineTo(7.478f)
                verticalLineTo(7.475f)
                verticalLineTo(7.472f)
                verticalLineTo(7.469f)
                verticalLineTo(7.466f)
                verticalLineTo(7.463f)
                verticalLineTo(7.46f)
                verticalLineTo(7.457f)
                verticalLineTo(7.454f)
                verticalLineTo(7.451f)
                verticalLineTo(7.448f)
                verticalLineTo(7.445f)
                verticalLineTo(7.442f)
                verticalLineTo(7.439f)
                verticalLineTo(7.436f)
                verticalLineTo(7.433f)
                verticalLineTo(7.43f)
                verticalLineTo(7.427f)
                verticalLineTo(7.424f)
                verticalLineTo(7.421f)
                verticalLineTo(7.418f)
                verticalLineTo(7.415f)
                verticalLineTo(7.412f)
                verticalLineTo(7.409f)
                verticalLineTo(7.406f)
                verticalLineTo(7.403f)
                verticalLineTo(7.4f)
                verticalLineTo(7.397f)
                verticalLineTo(7.393f)
                verticalLineTo(7.39f)
                verticalLineTo(7.387f)
                verticalLineTo(7.384f)
                verticalLineTo(7.381f)
                verticalLineTo(7.378f)
                verticalLineTo(7.375f)
                verticalLineTo(7.372f)
                verticalLineTo(7.369f)
                verticalLineTo(7.366f)
                verticalLineTo(7.363f)
                verticalLineTo(7.36f)
                verticalLineTo(7.357f)
                verticalLineTo(7.354f)
                verticalLineTo(7.35f)
                verticalLineTo(7.347f)
                verticalLineTo(7.344f)
                verticalLineTo(7.341f)
                verticalLineTo(7.338f)
                verticalLineTo(7.335f)
                verticalLineTo(7.332f)
                verticalLineTo(7.329f)
                verticalLineTo(7.326f)
                verticalLineTo(7.323f)
                verticalLineTo(7.319f)
                verticalLineTo(7.316f)
                verticalLineTo(7.313f)
                verticalLineTo(7.31f)
                verticalLineTo(7.307f)
                verticalLineTo(7.304f)
                verticalLineTo(7.301f)
                verticalLineTo(7.298f)
                verticalLineTo(7.294f)
                verticalLineTo(7.291f)
                verticalLineTo(7.288f)
                verticalLineTo(7.285f)
                verticalLineTo(7.282f)
                verticalLineTo(7.279f)
                verticalLineTo(7.275f)
                verticalLineTo(7.272f)
                verticalLineTo(7.269f)
                verticalLineTo(7.266f)
                verticalLineTo(7.263f)
                verticalLineTo(7.26f)
                verticalLineTo(7.257f)
                verticalLineTo(7.253f)
                verticalLineTo(7.25f)
                verticalLineTo(7.247f)
                verticalLineTo(7.244f)
                verticalLineTo(7.241f)
                verticalLineTo(7.237f)
                verticalLineTo(7.234f)
                verticalLineTo(7.231f)
                verticalLineTo(7.228f)
                verticalLineTo(7.225f)
                verticalLineTo(7.222f)
                verticalLineTo(7.218f)
                verticalLineTo(7.215f)
                verticalLineTo(7.212f)
                verticalLineTo(7.209f)
                verticalLineTo(7.206f)
                verticalLineTo(7.202f)
                verticalLineTo(7.199f)
                verticalLineTo(7.196f)
                verticalLineTo(7.193f)
                verticalLineTo(7.19f)
                verticalLineTo(7.186f)
                verticalLineTo(7.183f)
                verticalLineTo(7.18f)
                verticalLineTo(7.177f)
                verticalLineTo(7.174f)
                verticalLineTo(7.17f)
                verticalLineTo(7.167f)
                verticalLineTo(7.164f)
                verticalLineTo(7.161f)
                verticalLineTo(7.158f)
                verticalLineTo(7.154f)
                verticalLineTo(7.151f)
                verticalLineTo(7.148f)
                verticalLineTo(7.145f)
                verticalLineTo(7.141f)
                verticalLineTo(7.138f)
                verticalLineTo(7.135f)
                verticalLineTo(7.132f)
                verticalLineTo(7.129f)
                verticalLineTo(7.125f)
                verticalLineTo(7.122f)
                verticalLineTo(7.119f)
                verticalLineTo(7.116f)
                verticalLineTo(7.112f)
                verticalLineTo(7.109f)
                verticalLineTo(7.106f)
                verticalLineTo(7.103f)
                verticalLineTo(7.1f)
                verticalLineTo(7.096f)
                verticalLineTo(7.093f)
                verticalLineTo(7.09f)
                verticalLineTo(7.087f)
                verticalLineTo(7.083f)
                verticalLineTo(7.08f)
                verticalLineTo(7.077f)
                verticalLineTo(7.074f)
                verticalLineTo(7.07f)
                verticalLineTo(7.067f)
                verticalLineTo(7.064f)
                verticalLineTo(7.061f)
                verticalLineTo(7.057f)
                verticalLineTo(7.054f)
                verticalLineTo(7.051f)
                verticalLineTo(7.048f)
                verticalLineTo(7.045f)
                verticalLineTo(7.041f)
                verticalLineTo(7.038f)
                verticalLineTo(7.035f)
                verticalLineTo(7.032f)
                verticalLineTo(7.028f)
                verticalLineTo(7.025f)
                verticalLineTo(7.022f)
                verticalLineTo(7.019f)
                verticalLineTo(7.015f)
                verticalLineTo(7.012f)
                verticalLineTo(7.009f)
                verticalLineTo(7.006f)
                verticalLineTo(7.002f)
                verticalLineTo(6.999f)
                verticalLineTo(6.996f)
                verticalLineTo(6.993f)
                verticalLineTo(6.99f)
                verticalLineTo(6.986f)
                verticalLineTo(6.983f)
                verticalLineTo(6.98f)
                verticalLineTo(6.977f)
                verticalLineTo(6.973f)
                verticalLineTo(6.97f)
                verticalLineTo(6.967f)
                verticalLineTo(6.964f)
                verticalLineTo(6.96f)
                verticalLineTo(6.957f)
                verticalLineTo(6.954f)
                verticalLineTo(6.951f)
                verticalLineTo(6.948f)
                verticalLineTo(6.944f)
                verticalLineTo(6.941f)
                verticalLineTo(6.938f)
                verticalLineTo(6.935f)
                verticalLineTo(6.931f)
                verticalLineTo(6.928f)
                verticalLineTo(6.925f)
                verticalLineTo(6.922f)
                verticalLineTo(6.919f)
                verticalLineTo(6.915f)
                verticalLineTo(6.912f)
                verticalLineTo(6.909f)
                verticalLineTo(6.906f)
                verticalLineTo(6.902f)
                verticalLineTo(6.899f)
                verticalLineTo(6.896f)
                verticalLineTo(6.893f)
                verticalLineTo(6.89f)
                verticalLineTo(6.886f)
                verticalLineTo(6.883f)
                verticalLineTo(6.88f)
                verticalLineTo(6.877f)
                verticalLineTo(6.874f)
                verticalLineTo(6.87f)
                verticalLineTo(6.867f)
                verticalLineTo(6.864f)
                verticalLineTo(6.861f)
                verticalLineTo(6.858f)
                verticalLineTo(6.854f)
                verticalLineTo(6.851f)
                verticalLineTo(6.848f)
                verticalLineTo(6.845f)
                verticalLineTo(6.842f)
                verticalLineTo(6.839f)
                verticalLineTo(6.835f)
                verticalLineTo(6.832f)
                verticalLineTo(6.829f)
                verticalLineTo(6.826f)
                verticalLineTo(6.823f)
                verticalLineTo(6.819f)
                verticalLineTo(6.816f)
                verticalLineTo(6.813f)
                verticalLineTo(6.81f)
                verticalLineTo(6.807f)
                verticalLineTo(6.804f)
                verticalLineTo(6.8f)
                verticalLineTo(6.797f)
                verticalLineTo(6.794f)
                verticalLineTo(6.791f)
                verticalLineTo(6.788f)
                verticalLineTo(6.785f)
                verticalLineTo(6.782f)
                verticalLineTo(6.778f)
                verticalLineTo(6.775f)
                verticalLineTo(6.772f)
                verticalLineTo(6.769f)
                verticalLineTo(6.766f)
                verticalLineTo(6.763f)
                verticalLineTo(6.76f)
                verticalLineTo(6.756f)
                verticalLineTo(6.753f)
                verticalLineTo(6.75f)
                verticalLineTo(6.747f)
                verticalLineTo(6.744f)
                verticalLineTo(6.741f)
                verticalLineTo(6.738f)
                verticalLineTo(6.735f)
                verticalLineTo(6.731f)
                verticalLineTo(6.728f)
                verticalLineTo(6.725f)
                verticalLineTo(6.722f)
                verticalLineTo(6.719f)
                verticalLineTo(6.716f)
                verticalLineTo(6.713f)
                verticalLineTo(6.71f)
                verticalLineTo(6.707f)
                verticalLineTo(6.704f)
                verticalLineTo(6.701f)
                verticalLineTo(6.697f)
                verticalLineTo(6.694f)
                verticalLineTo(6.691f)
                verticalLineTo(6.688f)
                verticalLineTo(6.685f)
                verticalLineTo(6.682f)
                verticalLineTo(6.679f)
                verticalLineTo(6.676f)
                verticalLineTo(6.673f)
                verticalLineTo(6.67f)
                verticalLineTo(6.667f)
                verticalLineTo(6.664f)
                verticalLineTo(6.661f)
                verticalLineTo(6.658f)
                verticalLineTo(6.655f)
                verticalLineTo(6.652f)
                verticalLineTo(6.649f)
                verticalLineTo(6.646f)
                verticalLineTo(6.643f)
                verticalLineTo(6.64f)
                verticalLineTo(6.637f)
                verticalLineTo(6.634f)
                verticalLineTo(6.631f)
                verticalLineTo(6.628f)
                verticalLineTo(6.625f)
                verticalLineTo(6.622f)
                verticalLineTo(6.619f)
                verticalLineTo(6.616f)
                verticalLineTo(6.613f)
                verticalLineTo(6.61f)
                verticalLineTo(6.607f)
                verticalLineTo(6.604f)
                verticalLineTo(6.601f)
                verticalLineTo(6.598f)
                verticalLineTo(6.595f)
                verticalLineTo(6.592f)
                verticalLineTo(6.589f)
                verticalLineTo(6.586f)
                verticalLineTo(6.583f)
                verticalLineTo(6.58f)
                verticalLineTo(6.577f)
                verticalLineTo(6.574f)
                verticalLineTo(6.571f)
                verticalLineTo(6.568f)
                verticalLineTo(6.566f)
                verticalLineTo(6.563f)
                verticalLineTo(6.56f)
                verticalLineTo(6.557f)
                verticalLineTo(6.554f)
                verticalLineTo(6.551f)
                verticalLineTo(6.548f)
                verticalLineTo(6.545f)
                verticalLineTo(6.542f)
                verticalLineTo(6.54f)
                verticalLineTo(6.537f)
                verticalLineTo(6.534f)
                verticalLineTo(6.531f)
                verticalLineTo(6.528f)
                verticalLineTo(6.525f)
                verticalLineTo(6.522f)
                verticalLineTo(6.52f)
                verticalLineTo(6.517f)
                verticalLineTo(6.514f)
                verticalLineTo(6.511f)
                verticalLineTo(6.508f)
                verticalLineTo(6.505f)
                verticalLineTo(6.503f)
                verticalLineTo(6.5f)
                verticalLineTo(6.497f)
                verticalLineTo(6.494f)
                verticalLineTo(6.491f)
                verticalLineTo(6.489f)
                verticalLineTo(6.486f)
                verticalLineTo(6.483f)
                verticalLineTo(6.48f)
                verticalLineTo(6.478f)
                verticalLineTo(6.475f)
                verticalLineTo(6.472f)
                verticalLineTo(6.469f)
                verticalLineTo(6.467f)
                verticalLineTo(6.464f)
                verticalLineTo(6.461f)
                verticalLineTo(6.458f)
                verticalLineTo(6.456f)
                verticalLineTo(6.453f)
                verticalLineTo(6.45f)
                verticalLineTo(6.447f)
                verticalLineTo(6.445f)
                verticalLineTo(6.442f)
                verticalLineTo(6.439f)
                verticalLineTo(6.437f)
                verticalLineTo(6.434f)
                verticalLineTo(6.431f)
                verticalLineTo(6.429f)
                verticalLineTo(6.426f)
                verticalLineTo(6.423f)
                verticalLineTo(6.421f)
                verticalLineTo(6.418f)
                verticalLineTo(6.415f)
                verticalLineTo(6.413f)
                verticalLineTo(6.41f)
                verticalLineTo(6.408f)
                verticalLineTo(6.405f)
                verticalLineTo(6.402f)
                verticalLineTo(6.4f)
                verticalLineTo(6.397f)
                verticalLineTo(6.394f)
                verticalLineTo(6.392f)
                verticalLineTo(6.389f)
                verticalLineTo(6.387f)
                verticalLineTo(6.384f)
                verticalLineTo(6.382f)
                verticalLineTo(6.379f)
                verticalLineTo(6.377f)
                verticalLineTo(6.374f)
                verticalLineTo(6.371f)
                verticalLineTo(6.369f)
                verticalLineTo(6.366f)
                verticalLineTo(6.364f)
                verticalLineTo(6.361f)
                verticalLineTo(6.359f)
                verticalLineTo(6.356f)
                verticalLineTo(6.231f)
                horizontalLineTo(14.448f)
                horizontalLineTo(11.287f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFFF50100))) {
                moveTo(11.084f, 6.106f)
                horizontalLineToRelative(3.6f)
                verticalLineToRelative(1.7f)
                horizontalLineToRelative(-3.6f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF50100))) {
                moveTo(12.689f, 8.156f)
                curveTo(12.804f, 8.156f, 13.035f, 8f, 13.092f, 7.963f)
                curveTo(13.304f, 7.807f, 13.457f, 7.951f, 13.582f, 8.024f)
                curveTo(13.716f, 8.096f, 13.966f, 8.18f, 14.12f, 8.024f)
                curveTo(14.273f, 7.867f, 14.359f, 7.879f, 14.465f, 7.879f)
                curveTo(14.484f, 7.698f, 14.484f, 7.517f, 14.484f, 7.312f)
                verticalLineTo(7.168f)
                curveTo(14.35f, 7.132f, 14.283f, 7.18f, 14.139f, 7.337f)
                curveTo(13.995f, 7.493f, 13.832f, 7.457f, 13.62f, 7.361f)
                curveTo(13.419f, 7.252f, 13.217f, 7.059f, 13.016f, 7.361f)
                curveTo(12.958f, 7.445f, 12.823f, 7.566f, 12.689f, 7.566f)
                curveTo(12.545f, 7.566f, 12.42f, 7.445f, 12.363f, 7.361f)
                curveTo(12.151f, 7.059f, 11.96f, 7.252f, 11.758f, 7.361f)
                curveTo(11.547f, 7.457f, 11.374f, 7.493f, 11.23f, 7.337f)
                curveTo(11.095f, 7.18f, 11.028f, 7.132f, 10.884f, 7.168f)
                verticalLineTo(7.312f)
                curveTo(10.884f, 7.517f, 10.894f, 7.698f, 10.913f, 7.879f)
                curveTo(11.019f, 7.879f, 11.095f, 7.867f, 11.249f, 8.024f)
                curveTo(11.403f, 8.18f, 11.662f, 8.096f, 11.787f, 8.024f)
                curveTo(11.921f, 7.951f, 12.075f, 7.807f, 12.286f, 7.963f)
                curveTo(12.344f, 8f, 12.564f, 8.156f, 12.689f, 8.156f)
                horizontalLineTo(12.689f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFD100)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(11.718f, 6.881f)
                curveTo(11.718f, 6.881f, 11.805f, 6.886f, 11.907f, 7.018f)
                curveTo(12.01f, 7.151f, 12.388f, 7.067f, 12.388f, 6.987f)
                curveTo(12.388f, 6.907f, 12.159f, 6.859f, 12.247f, 6.722f)
                curveTo(12.335f, 6.585f, 12.484f, 6.585f, 12.604f, 6.656f)
                curveTo(12.639f, 6.656f, 12.635f, 7.124f, 12.714f, 7.098f)
                curveTo(12.962f, 7.017f, 13.363f, 6.856f, 13.481f, 6.925f)
                curveTo(13.636f, 7.016f, 13.754f, 6.993f, 13.715f, 6.863f)
                curveTo(13.676f, 6.732f, 13.575f, 6.651f, 13.38f, 6.722f)
                curveTo(13.185f, 6.793f, 13.231f, 6.863f, 13.063f, 6.863f)
                curveTo(12.894f, 6.863f, 12.605f, 6.977f, 12.734f, 6.722f)
                curveTo(12.849f, 6.494f, 12.986f, 6.489f, 13.038f, 6.585f)
                curveTo(13.065f, 6.634f, 12.846f, 6.743f, 12.846f, 6.793f)
                curveTo(12.846f, 6.863f, 13.409f, 6.656f, 13.481f, 6.656f)
                curveTo(13.553f, 6.656f, 13.752f, 6.651f, 13.771f, 6.722f)
                curveTo(13.791f, 6.793f, 13.911f, 6.859f, 13.819f, 6.925f)
                curveTo(13.728f, 6.992f, 13.578f, 7.033f, 13.681f, 7.118f)
                curveTo(13.785f, 7.203f, 14.047f, 7.242f, 14.059f, 7.331f)
                curveTo(14.07f, 7.419f, 14.183f, 7.551f, 14.138f, 7.551f)
                curveTo(14.093f, 7.551f, 14.011f, 7.676f, 13.934f, 7.638f)
                curveTo(13.858f, 7.6f, 13.849f, 7.567f, 13.922f, 7.536f)
                curveTo(13.995f, 7.505f, 13.995f, 7.376f, 13.934f, 7.376f)
                curveTo(13.874f, 7.376f, 13.879f, 7.366f, 13.742f, 7.321f)
                curveTo(13.604f, 7.275f, 13.423f, 7.225f, 13.434f, 7.321f)
                curveTo(13.445f, 7.416f, 13.538f, 7.622f, 13.373f, 7.641f)
                curveTo(13.208f, 7.661f, 13.13f, 7.739f, 13.098f, 7.676f)
                curveTo(13.066f, 7.613f, 12.951f, 7.529f, 13.042f, 7.502f)
                curveTo(13.132f, 7.475f, 13.218f, 7.593f, 13.251f, 7.574f)
                curveTo(13.283f, 7.555f, 13.353f, 7.485f, 13.292f, 7.403f)
                curveTo(13.23f, 7.321f, 13.11f, 7.318f, 13.204f, 7.256f)
                curveTo(13.299f, 7.195f, 13.242f, 7.148f, 13.063f, 7.275f)
                curveTo(12.883f, 7.403f, 12.783f, 7.511f, 12.625f, 7.496f)
                curveTo(12.467f, 7.481f, 12.396f, 7.551f, 12.346f, 7.53f)
                curveTo(12.295f, 7.51f, 12.048f, 7.759f, 11.977f, 7.696f)
                curveTo(11.906f, 7.632f, 11.676f, 7.608f, 11.718f, 7.53f)
                curveTo(11.759f, 7.453f, 11.814f, 7.412f, 11.876f, 7.453f)
                curveTo(11.938f, 7.493f, 11.999f, 7.533f, 12.041f, 7.493f)
                curveTo(12.083f, 7.453f, 12.215f, 7.266f, 12.185f, 7.238f)
                curveTo(12.154f, 7.211f, 12.048f, 7.164f, 11.876f, 7.164f)
                curveTo(11.705f, 7.164f, 11.701f, 7.021f, 11.66f, 6.956f)
                curveTo(11.619f, 6.891f, 11.718f, 6.881f, 11.718f, 6.881f)
                close()
            }
            path(fill = SolidColor(Color(0xFF0B50A0))) {
                moveTo(12.689f, 9.356f)
                curveTo(12.804f, 9.356f, 13.035f, 9.2f, 13.092f, 9.163f)
                curveTo(13.304f, 9.007f, 13.457f, 9.151f, 13.582f, 9.224f)
                curveTo(13.716f, 9.296f, 13.966f, 9.38f, 14.12f, 9.224f)
                curveTo(14.273f, 9.067f, 14.359f, 9.079f, 14.465f, 9.079f)
                curveTo(14.484f, 8.898f, 14.484f, 8.717f, 14.484f, 8.512f)
                verticalLineTo(8.368f)
                curveTo(14.35f, 8.332f, 14.283f, 8.38f, 14.139f, 8.537f)
                curveTo(13.995f, 8.693f, 13.832f, 8.657f, 13.62f, 8.561f)
                curveTo(13.419f, 8.452f, 13.217f, 8.259f, 13.016f, 8.561f)
                curveTo(12.958f, 8.645f, 12.823f, 8.766f, 12.689f, 8.766f)
                curveTo(12.545f, 8.766f, 12.42f, 8.645f, 12.363f, 8.561f)
                curveTo(12.151f, 8.259f, 11.96f, 8.452f, 11.758f, 8.561f)
                curveTo(11.547f, 8.657f, 11.374f, 8.693f, 11.23f, 8.537f)
                curveTo(11.095f, 8.38f, 11.028f, 8.332f, 10.884f, 8.368f)
                verticalLineTo(8.512f)
                curveTo(10.884f, 8.717f, 10.894f, 8.898f, 10.913f, 9.079f)
                curveTo(11.019f, 9.079f, 11.095f, 9.067f, 11.249f, 9.224f)
                curveTo(11.403f, 9.38f, 11.662f, 9.296f, 11.787f, 9.224f)
                curveTo(11.921f, 9.151f, 12.075f, 9.007f, 12.286f, 9.163f)
                curveTo(12.344f, 9.2f, 12.564f, 9.356f, 12.689f, 9.356f)
                horizontalLineTo(12.689f)
                close()
            }
            path(fill = SolidColor(Color(0xFF0B50A0))) {
                moveTo(12.689f, 10.506f)
                curveTo(12.804f, 10.506f, 13.035f, 10.35f, 13.092f, 10.314f)
                curveTo(13.304f, 10.157f, 13.457f, 10.301f, 13.582f, 10.374f)
                curveTo(13.716f, 10.446f, 13.966f, 10.531f, 14.12f, 10.374f)
                curveTo(14.273f, 10.217f, 14.359f, 10.229f, 14.465f, 10.229f)
                curveTo(14.484f, 10.048f, 14.484f, 9.867f, 14.484f, 9.662f)
                verticalLineTo(9.518f)
                curveTo(14.35f, 9.482f, 14.283f, 9.53f, 14.139f, 9.687f)
                curveTo(13.995f, 9.843f, 13.832f, 9.807f, 13.62f, 9.711f)
                curveTo(13.419f, 9.602f, 13.217f, 9.409f, 13.016f, 9.711f)
                curveTo(12.958f, 9.795f, 12.823f, 9.916f, 12.689f, 9.916f)
                curveTo(12.545f, 9.916f, 12.42f, 9.795f, 12.363f, 9.711f)
                curveTo(12.151f, 9.409f, 11.96f, 9.602f, 11.758f, 9.711f)
                curveTo(11.547f, 9.807f, 11.374f, 9.843f, 11.23f, 9.687f)
                curveTo(11.095f, 9.53f, 11.028f, 9.482f, 10.884f, 9.518f)
                verticalLineTo(9.662f)
                curveTo(10.884f, 9.867f, 10.894f, 10.048f, 10.913f, 10.229f)
                curveTo(11.019f, 10.229f, 11.095f, 10.217f, 11.249f, 10.374f)
                curveTo(11.403f, 10.531f, 11.662f, 10.446f, 11.787f, 10.374f)
                curveTo(11.921f, 10.301f, 12.075f, 10.157f, 12.286f, 10.314f)
                curveTo(12.344f, 10.35f, 12.564f, 10.506f, 12.689f, 10.506f)
                horizontalLineTo(12.689f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF059334)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(12.901f, 10.149f)
                lineTo(12.615f, 10.318f)
                lineTo(12.696f, 9.974f)
                lineTo(12.422f, 9.72f)
                horizontalLineTo(12.78f)
                lineTo(12.9f, 9.394f)
                lineTo(13.041f, 9.72f)
                horizontalLineTo(13.346f)
                lineTo(13.106f, 9.974f)
                lineTo(13.222f, 10.318f)
                lineTo(12.901f, 10.149f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(12.901f, 10.149f)
                lineTo(12.615f, 10.318f)
                lineTo(12.696f, 9.974f)
                lineTo(12.422f, 9.72f)
                horizontalLineTo(12.78f)
                lineTo(12.9f, 9.394f)
                lineTo(13.041f, 9.72f)
                horizontalLineTo(13.346f)
                lineTo(13.106f, 9.974f)
                lineTo(13.222f, 10.318f)
                lineTo(12.901f, 10.149f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFFFFD100))) {
                moveTo(12.901f, 10.149f)
                lineTo(13.158f, 9.662f)
                lineTo(12.885f, 9.519f)
                lineTo(12.62f, 9.676f)
                lineTo(12.901f, 10.149f)
                close()
                moveTo(12.615f, 10.318f)
                lineTo(12.079f, 10.191f)
                lineTo(11.781f, 11.452f)
                lineTo(12.895f, 10.792f)
                lineTo(12.615f, 10.318f)
                close()
                moveTo(12.696f, 9.974f)
                lineTo(13.231f, 10.101f)
                lineTo(13.306f, 9.788f)
                lineTo(13.07f, 9.57f)
                lineTo(12.696f, 9.974f)
                close()
                moveTo(12.422f, 9.72f)
                verticalLineTo(9.17f)
                horizontalLineTo(11.017f)
                lineTo(12.049f, 10.125f)
                lineTo(12.422f, 9.72f)
                close()
                moveTo(12.78f, 9.72f)
                verticalLineTo(10.271f)
                horizontalLineTo(13.164f)
                lineTo(13.296f, 9.911f)
                lineTo(12.78f, 9.72f)
                close()
                moveTo(12.9f, 9.394f)
                lineTo(13.405f, 9.176f)
                lineTo(12.86f, 7.913f)
                lineTo(12.384f, 9.204f)
                lineTo(12.9f, 9.394f)
                close()
                moveTo(13.041f, 9.72f)
                lineTo(12.536f, 9.938f)
                lineTo(12.679f, 10.271f)
                horizontalLineTo(13.041f)
                verticalLineTo(9.72f)
                close()
                moveTo(13.346f, 9.72f)
                lineTo(13.746f, 10.099f)
                lineTo(14.624f, 9.17f)
                horizontalLineTo(13.346f)
                verticalLineTo(9.72f)
                close()
                moveTo(13.106f, 9.974f)
                lineTo(12.707f, 9.596f)
                lineTo(12.48f, 9.835f)
                lineTo(12.585f, 10.148f)
                lineTo(13.106f, 9.974f)
                close()
                moveTo(13.222f, 10.318f)
                lineTo(12.965f, 10.805f)
                lineTo(14.179f, 11.446f)
                lineTo(13.743f, 10.144f)
                lineTo(13.222f, 10.318f)
                close()
                moveTo(12.62f, 9.676f)
                lineTo(12.334f, 9.845f)
                lineTo(12.895f, 10.792f)
                lineTo(13.181f, 10.622f)
                lineTo(12.62f, 9.676f)
                close()
                moveTo(13.15f, 10.445f)
                lineTo(13.231f, 10.101f)
                lineTo(12.161f, 9.847f)
                lineTo(12.079f, 10.191f)
                lineTo(13.15f, 10.445f)
                close()
                moveTo(13.07f, 9.57f)
                lineTo(12.795f, 9.317f)
                lineTo(12.049f, 10.125f)
                lineTo(12.323f, 10.378f)
                lineTo(13.07f, 9.57f)
                close()
                moveTo(12.422f, 10.271f)
                horizontalLineTo(12.78f)
                verticalLineTo(9.17f)
                horizontalLineTo(12.422f)
                verticalLineTo(10.271f)
                close()
                moveTo(13.296f, 9.911f)
                lineTo(13.416f, 9.584f)
                lineTo(12.384f, 9.204f)
                lineTo(12.264f, 9.53f)
                lineTo(13.296f, 9.911f)
                close()
                moveTo(12.395f, 9.612f)
                lineTo(12.536f, 9.938f)
                lineTo(13.546f, 9.503f)
                lineTo(13.405f, 9.176f)
                lineTo(12.395f, 9.612f)
                close()
                moveTo(13.041f, 10.271f)
                horizontalLineTo(13.346f)
                verticalLineTo(9.17f)
                horizontalLineTo(13.041f)
                verticalLineTo(10.271f)
                close()
                moveTo(12.947f, 9.342f)
                lineTo(12.707f, 9.596f)
                lineTo(13.506f, 10.352f)
                lineTo(13.746f, 10.099f)
                lineTo(12.947f, 9.342f)
                close()
                moveTo(12.585f, 10.148f)
                lineTo(12.7f, 10.493f)
                lineTo(13.743f, 10.144f)
                lineTo(13.628f, 9.799f)
                lineTo(12.585f, 10.148f)
                close()
                moveTo(13.479f, 9.832f)
                lineTo(13.158f, 9.662f)
                lineTo(12.644f, 10.635f)
                lineTo(12.965f, 10.805f)
                lineTo(13.479f, 9.832f)
                close()
            }
        }
        path(
            fill = SolidColor(Color(0xFF059334)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(12.101f, 9.149f)
            lineTo(11.815f, 9.318f)
            lineTo(11.896f, 8.974f)
            lineTo(11.622f, 8.72f)
            horizontalLineTo(11.98f)
            lineTo(12.1f, 8.394f)
            lineTo(12.241f, 8.72f)
            horizontalLineTo(12.546f)
            lineTo(12.307f, 8.974f)
            lineTo(12.422f, 9.318f)
            lineTo(12.101f, 9.149f)
            close()
        }
        group(
            clipPathData = PathData {
                moveTo(12.101f, 9.149f)
                lineTo(11.815f, 9.318f)
                lineTo(11.896f, 8.974f)
                lineTo(11.622f, 8.72f)
                horizontalLineTo(11.98f)
                lineTo(12.1f, 8.394f)
                lineTo(12.241f, 8.72f)
                horizontalLineTo(12.546f)
                lineTo(12.307f, 8.974f)
                lineTo(12.422f, 9.318f)
                lineTo(12.101f, 9.149f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFFFFD100))) {
                moveTo(12.101f, 9.149f)
                lineTo(12.358f, 8.662f)
                lineTo(12.085f, 8.519f)
                lineTo(11.82f, 8.676f)
                lineTo(12.101f, 9.149f)
                close()
                moveTo(11.815f, 9.318f)
                lineTo(11.28f, 9.191f)
                lineTo(10.981f, 10.452f)
                lineTo(12.095f, 9.792f)
                lineTo(11.815f, 9.318f)
                close()
                moveTo(11.896f, 8.974f)
                lineTo(12.432f, 9.101f)
                lineTo(12.506f, 8.788f)
                lineTo(12.27f, 8.57f)
                lineTo(11.896f, 8.974f)
                close()
                moveTo(11.622f, 8.72f)
                verticalLineTo(8.17f)
                horizontalLineTo(10.217f)
                lineTo(11.249f, 9.124f)
                lineTo(11.622f, 8.72f)
                close()
                moveTo(11.98f, 8.72f)
                verticalLineTo(9.271f)
                horizontalLineTo(12.364f)
                lineTo(12.496f, 8.911f)
                lineTo(11.98f, 8.72f)
                close()
                moveTo(12.1f, 8.394f)
                lineTo(12.605f, 8.176f)
                lineTo(12.06f, 6.913f)
                lineTo(11.584f, 8.204f)
                lineTo(12.1f, 8.394f)
                close()
                moveTo(12.241f, 8.72f)
                lineTo(11.736f, 8.938f)
                lineTo(11.88f, 9.271f)
                horizontalLineTo(12.241f)
                verticalLineTo(8.72f)
                close()
                moveTo(12.546f, 8.72f)
                lineTo(12.946f, 9.099f)
                lineTo(13.825f, 8.17f)
                horizontalLineTo(12.546f)
                verticalLineTo(8.72f)
                close()
                moveTo(12.307f, 8.974f)
                lineTo(11.907f, 8.596f)
                lineTo(11.68f, 8.835f)
                lineTo(11.785f, 9.148f)
                lineTo(12.307f, 8.974f)
                close()
                moveTo(12.422f, 9.318f)
                lineTo(12.165f, 9.805f)
                lineTo(13.379f, 10.446f)
                lineTo(12.943f, 9.144f)
                lineTo(12.422f, 9.318f)
                close()
                moveTo(11.82f, 8.676f)
                lineTo(11.534f, 8.845f)
                lineTo(12.095f, 9.792f)
                lineTo(12.381f, 9.622f)
                lineTo(11.82f, 8.676f)
                close()
                moveTo(12.35f, 9.445f)
                lineTo(12.432f, 9.101f)
                lineTo(11.361f, 8.847f)
                lineTo(11.28f, 9.191f)
                lineTo(12.35f, 9.445f)
                close()
                moveTo(12.27f, 8.57f)
                lineTo(11.996f, 8.317f)
                lineTo(11.249f, 9.124f)
                lineTo(11.523f, 9.378f)
                lineTo(12.27f, 8.57f)
                close()
                moveTo(11.622f, 9.271f)
                horizontalLineTo(11.98f)
                verticalLineTo(8.17f)
                horizontalLineTo(11.622f)
                verticalLineTo(9.271f)
                close()
                moveTo(12.496f, 8.911f)
                lineTo(12.616f, 8.584f)
                lineTo(11.584f, 8.204f)
                lineTo(11.464f, 8.53f)
                lineTo(12.496f, 8.911f)
                close()
                moveTo(11.595f, 8.612f)
                lineTo(11.736f, 8.938f)
                lineTo(12.746f, 8.503f)
                lineTo(12.605f, 8.176f)
                lineTo(11.595f, 8.612f)
                close()
                moveTo(12.241f, 9.271f)
                horizontalLineTo(12.546f)
                verticalLineTo(8.17f)
                horizontalLineTo(12.241f)
                verticalLineTo(9.271f)
                close()
                moveTo(12.147f, 8.342f)
                lineTo(11.907f, 8.596f)
                lineTo(12.706f, 9.352f)
                lineTo(12.946f, 9.099f)
                lineTo(12.147f, 8.342f)
                close()
                moveTo(11.785f, 9.148f)
                lineTo(11.9f, 9.493f)
                lineTo(12.943f, 9.144f)
                lineTo(12.828f, 8.799f)
                lineTo(11.785f, 9.148f)
                close()
                moveTo(12.679f, 8.832f)
                lineTo(12.358f, 8.662f)
                lineTo(11.844f, 9.635f)
                lineTo(12.165f, 9.805f)
                lineTo(12.679f, 8.832f)
                close()
            }
        }
        path(
            fill = SolidColor(Color(0xFF059334)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(13.701f, 9.149f)
            lineTo(13.415f, 9.318f)
            lineTo(13.496f, 8.974f)
            lineTo(13.222f, 8.72f)
            horizontalLineTo(13.58f)
            lineTo(13.7f, 8.394f)
            lineTo(13.841f, 8.72f)
            horizontalLineTo(14.146f)
            lineTo(13.906f, 8.974f)
            lineTo(14.022f, 9.318f)
            lineTo(13.701f, 9.149f)
            close()
        }
        group(
            clipPathData = PathData {
                moveTo(13.701f, 9.149f)
                lineTo(13.415f, 9.318f)
                lineTo(13.496f, 8.974f)
                lineTo(13.222f, 8.72f)
                horizontalLineTo(13.58f)
                lineTo(13.7f, 8.394f)
                lineTo(13.841f, 8.72f)
                horizontalLineTo(14.146f)
                lineTo(13.906f, 8.974f)
                lineTo(14.022f, 9.318f)
                lineTo(13.701f, 9.149f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFFFFD100))) {
                moveTo(13.701f, 9.149f)
                lineTo(13.958f, 8.662f)
                lineTo(13.685f, 8.519f)
                lineTo(13.42f, 8.676f)
                lineTo(13.701f, 9.149f)
                close()
                moveTo(13.415f, 9.318f)
                lineTo(12.88f, 9.191f)
                lineTo(12.581f, 10.452f)
                lineTo(13.695f, 9.792f)
                lineTo(13.415f, 9.318f)
                close()
                moveTo(13.496f, 8.974f)
                lineTo(14.031f, 9.101f)
                lineTo(14.106f, 8.788f)
                lineTo(13.87f, 8.57f)
                lineTo(13.496f, 8.974f)
                close()
                moveTo(13.222f, 8.72f)
                verticalLineTo(8.17f)
                horizontalLineTo(11.817f)
                lineTo(12.849f, 9.124f)
                lineTo(13.222f, 8.72f)
                close()
                moveTo(13.58f, 8.72f)
                verticalLineTo(9.271f)
                horizontalLineTo(13.964f)
                lineTo(14.096f, 8.911f)
                lineTo(13.58f, 8.72f)
                close()
                moveTo(13.7f, 8.394f)
                lineTo(14.205f, 8.176f)
                lineTo(13.66f, 6.913f)
                lineTo(13.184f, 8.204f)
                lineTo(13.7f, 8.394f)
                close()
                moveTo(13.841f, 8.72f)
                lineTo(13.336f, 8.938f)
                lineTo(13.479f, 9.271f)
                horizontalLineTo(13.841f)
                verticalLineTo(8.72f)
                close()
                moveTo(14.146f, 8.72f)
                lineTo(14.546f, 9.099f)
                lineTo(15.425f, 8.17f)
                horizontalLineTo(14.146f)
                verticalLineTo(8.72f)
                close()
                moveTo(13.906f, 8.974f)
                lineTo(13.507f, 8.596f)
                lineTo(13.28f, 8.835f)
                lineTo(13.385f, 9.148f)
                lineTo(13.906f, 8.974f)
                close()
                moveTo(14.022f, 9.318f)
                lineTo(13.765f, 9.805f)
                lineTo(14.979f, 10.446f)
                lineTo(14.543f, 9.144f)
                lineTo(14.022f, 9.318f)
                close()
                moveTo(13.42f, 8.676f)
                lineTo(13.134f, 8.845f)
                lineTo(13.695f, 9.792f)
                lineTo(13.981f, 9.622f)
                lineTo(13.42f, 8.676f)
                close()
                moveTo(13.95f, 9.445f)
                lineTo(14.031f, 9.101f)
                lineTo(12.961f, 8.847f)
                lineTo(12.88f, 9.191f)
                lineTo(13.95f, 9.445f)
                close()
                moveTo(13.87f, 8.57f)
                lineTo(13.595f, 8.317f)
                lineTo(12.849f, 9.124f)
                lineTo(13.123f, 9.378f)
                lineTo(13.87f, 8.57f)
                close()
                moveTo(13.222f, 9.271f)
                horizontalLineTo(13.58f)
                verticalLineTo(8.17f)
                horizontalLineTo(13.222f)
                verticalLineTo(9.271f)
                close()
                moveTo(14.096f, 8.911f)
                lineTo(14.217f, 8.584f)
                lineTo(13.184f, 8.204f)
                lineTo(13.064f, 8.53f)
                lineTo(14.096f, 8.911f)
                close()
                moveTo(13.195f, 8.612f)
                lineTo(13.336f, 8.938f)
                lineTo(14.346f, 8.503f)
                lineTo(14.205f, 8.176f)
                lineTo(13.195f, 8.612f)
                close()
                moveTo(13.841f, 9.271f)
                horizontalLineTo(14.146f)
                verticalLineTo(8.17f)
                horizontalLineTo(13.841f)
                verticalLineTo(9.271f)
                close()
                moveTo(13.747f, 8.342f)
                lineTo(13.507f, 8.596f)
                lineTo(14.306f, 9.352f)
                lineTo(14.546f, 9.099f)
                lineTo(13.747f, 8.342f)
                close()
                moveTo(13.385f, 9.148f)
                lineTo(13.5f, 9.493f)
                lineTo(14.543f, 9.144f)
                lineTo(14.428f, 8.799f)
                lineTo(13.385f, 9.148f)
                close()
                moveTo(14.279f, 8.832f)
                lineTo(13.958f, 8.662f)
                lineTo(13.444f, 9.635f)
                lineTo(13.765f, 9.805f)
                lineTo(14.279f, 8.832f)
                close()
            }
        }
        path(fill = SolidColor(Color(0xFFFFD100))) {
            moveTo(10.524f, 10.39f)
            curveTo(10.57f, 10.521f, 10.899f, 10.693f, 11.282f, 10.472f)
            curveTo(11.542f, 10.316f, 11.71f, 10.095f, 11.871f, 9.701f)
            curveTo(11.917f, 9.603f, 11.94f, 9.48f, 11.833f, 9.407f)
            curveTo(11.749f, 9.341f, 11.611f, 9.267f, 11.55f, 9.202f)
            curveTo(11.519f, 9.169f, 11.488f, 9.144f, 11.465f, 9.12f)
            curveTo(11.481f, 9.136f, 11.496f, 9.153f, 11.511f, 9.177f)
            curveTo(11.665f, 9.374f, 11.504f, 9.66f, 11.335f, 9.833f)
            curveTo(11.213f, 9.955f, 10.991f, 10.259f, 10.669f, 9.972f)
            curveTo(10.6f, 9.906f, 10.44f, 10.177f, 10.524f, 10.39f)
            lineTo(10.524f, 10.39f)
            close()
        }
        path(fill = SolidColor(Color(0xFFFFD100))) {
            moveTo(15.178f, 10.39f)
            curveTo(15.125f, 10.521f, 14.796f, 10.693f, 14.42f, 10.472f)
            curveTo(14.16f, 10.316f, 13.992f, 10.095f, 13.823f, 9.701f)
            curveTo(13.785f, 9.603f, 13.762f, 9.48f, 13.869f, 9.407f)
            curveTo(13.953f, 9.341f, 14.091f, 9.267f, 14.153f, 9.202f)
            curveTo(14.183f, 9.169f, 14.206f, 9.144f, 14.237f, 9.12f)
            curveTo(14.221f, 9.136f, 14.206f, 9.153f, 14.191f, 9.177f)
            curveTo(14.038f, 9.374f, 14.198f, 9.66f, 14.359f, 9.833f)
            curveTo(14.482f, 9.955f, 14.711f, 10.259f, 15.033f, 9.972f)
            curveTo(15.102f, 9.906f, 15.255f, 10.177f, 15.178f, 10.39f)
            lineTo(15.178f, 10.39f)
            close()
        }
        path(fill = SolidColor(Color(0xFFFFD100))) {
            moveTo(12.851f, 11.094f)
            curveTo(13.464f, 11.094f, 14.405f, 10.799f, 14.91f, 9.767f)
            curveTo(14.995f, 9.595f, 14.91f, 9.505f, 14.811f, 9.448f)
            curveTo(14.704f, 9.398f, 14.574f, 9.284f, 14.505f, 9.21f)
            curveTo(14.627f, 9.341f, 14.604f, 9.431f, 14.52f, 9.579f)
            curveTo(14.13f, 10.275f, 13.594f, 10.627f, 12.851f, 10.627f)
            curveTo(12.108f, 10.627f, 11.573f, 10.275f, 11.182f, 9.579f)
            curveTo(11.098f, 9.431f, 11.075f, 9.341f, 11.19f, 9.21f)
            curveTo(11.129f, 9.284f, 10.991f, 9.398f, 10.884f, 9.448f)
            curveTo(10.784f, 9.505f, 10.7f, 9.595f, 10.784f, 9.767f)
            curveTo(11.289f, 10.799f, 12.239f, 11.094f, 12.851f, 11.094f)
            horizontalLineTo(12.851f)
            close()
        }
        path(fill = SolidColor(Color(0xFFF50100))) {
            moveTo(11.435f, 9.71f)
            curveTo(11.42f, 9.628f, 11.32f, 9.66f, 11.289f, 9.759f)
            curveTo(11.251f, 9.701f, 11.213f, 9.644f, 11.182f, 9.579f)
            curveTo(11.09f, 9.431f, 11.075f, 9.333f, 11.205f, 9.194f)
            curveTo(11.266f, 9.128f, 11.389f, 9.054f, 11.473f, 9.136f)
            curveTo(11.649f, 9.292f, 11.557f, 9.546f, 11.435f, 9.71f)
            lineTo(11.435f, 9.71f)
            close()
        }
        path(fill = SolidColor(Color(0xFFF50100))) {
            moveTo(14.26f, 9.71f)
            curveTo(14.275f, 9.628f, 14.382f, 9.66f, 14.413f, 9.759f)
            curveTo(14.451f, 9.701f, 14.489f, 9.644f, 14.52f, 9.579f)
            curveTo(14.612f, 9.431f, 14.627f, 9.333f, 14.489f, 9.194f)
            curveTo(14.436f, 9.128f, 14.313f, 9.054f, 14.221f, 9.136f)
            curveTo(14.053f, 9.292f, 14.137f, 9.546f, 14.26f, 9.71f)
            lineTo(14.26f, 9.71f)
            close()
        }
        path(
            fill = SolidColor(Color(0xFFFFD100)),
            pathFillType = PathFillType.EvenOdd
        ) {
            moveTo(12.492f, 4.272f)
            curveTo(12.265f, 3.946f, 11.979f, 3.72f, 11.81f, 3.587f)
            curveTo(11.723f, 3.518f, 11.667f, 3.474f, 11.667f, 3.454f)
            curveTo(11.667f, 3.396f, 12.122f, 3.55f, 12.587f, 3.942f)
            curveTo(12.597f, 3.919f, 12.608f, 3.896f, 12.62f, 3.874f)
            curveTo(12.483f, 3.601f, 12.248f, 3.358f, 12.115f, 3.22f)
            lineTo(12.115f, 3.22f)
            curveTo(12.051f, 3.155f, 12.011f, 3.113f, 12.014f, 3.103f)
            curveTo(12.024f, 3.072f, 12.407f, 3.32f, 12.746f, 3.696f)
            curveTo(12.779f, 3.662f, 12.814f, 3.635f, 12.851f, 3.615f)
            lineTo(12.627f, 3.242f)
            horizontalLineTo(13.427f)
            lineTo(13.188f, 3.639f)
            curveTo(13.24f, 3.676f, 13.288f, 3.728f, 13.331f, 3.791f)
            curveTo(13.687f, 3.362f, 14.135f, 3.07f, 14.146f, 3.103f)
            lineTo(13.876f, 3.716f)
            curveTo(13.748f, 3.8f, 13.612f, 3.903f, 13.477f, 4.026f)
            lineTo(13.453f, 4.048f)
            lineTo(13.461f, 4.073f)
            curveTo(13.463f, 4.071f, 13.464f, 4.069f, 13.465f, 4.067f)
            curveTo(13.469f, 4.053f, 13.473f, 4.04f, 13.477f, 4.026f)
            lineTo(13.532f, 4.497f)
            curveTo(13.533f, 4.521f, 13.533f, 4.546f, 13.533f, 4.57f)
            curveTo(13.763f, 4.315f, 14.006f, 4.214f, 14.006f, 4.248f)
            curveTo(14.006f, 4.259f, 13.98f, 4.284f, 13.94f, 4.321f)
            curveTo(13.837f, 4.419f, 13.636f, 4.608f, 13.535f, 4.899f)
            curveTo(13.531f, 4.911f, 13.519f, 4.91f, 13.504f, 4.903f)
            curveTo(13.432f, 5.294f, 13.233f, 5.575f, 13f, 5.575f)
            curveTo(12.709f, 5.575f, 12.473f, 5.139f, 12.467f, 4.596f)
            curveTo(12.378f, 4.47f, 12.282f, 4.38f, 12.22f, 4.321f)
            lineTo(12.22f, 4.321f)
            curveTo(12.18f, 4.284f, 12.154f, 4.259f, 12.154f, 4.248f)
            curveTo(12.154f, 4.222f, 12.3f, 4.277f, 12.473f, 4.421f)
            curveTo(12.477f, 4.37f, 12.483f, 4.32f, 12.492f, 4.272f)
            close()
            moveTo(13.532f, 4.497f)
            curveTo(13.766f, 4.048f, 14.145f, 3.749f, 14.35f, 3.587f)
            curveTo(14.437f, 3.518f, 14.493f, 3.474f, 14.493f, 3.454f)
            curveTo(14.493f, 3.409f, 14.217f, 3.492f, 13.876f, 3.716f)
            lineTo(13.532f, 4.497f)
            close()
        }
        path(fill = SolidColor(Color(0xFF059334))) {
            moveTo(11.893f, 5.151f)
            curveTo(11.829f, 5.042f, 11.655f, 4.993f, 11.581f, 5.091f)
            curveTo(11.554f, 5.115f, 11.517f, 5.115f, 11.49f, 5.127f)
            curveTo(11.444f, 5.127f, 11.385f, 5.158f, 11.403f, 5.279f)
            curveTo(11.453f, 5.279f, 11.453f, 5.31f, 11.48f, 5.31f)
            curveTo(11.499f, 5.297f, 11.546f, 5.521f, 11.638f, 5.509f)
            curveTo(11.739f, 5.509f, 11.829f, 5.565f, 11.847f, 5.589f)
            curveTo(11.875f, 5.626f, 11.911f, 5.723f, 11.865f, 5.772f)
            curveTo(11.801f, 5.845f, 11.755f, 6.015f, 11.865f, 6.149f)
            curveTo(11.984f, 6.271f, 12.287f, 6.453f, 12.626f, 6.101f)
            curveTo(12.956f, 5.76f, 13.47f, 5.955f, 13.506f, 6.076f)
            curveTo(13.552f, 6.198f, 13.57f, 6.271f, 13.58f, 6.332f)
            curveTo(13.589f, 6.38f, 13.836f, 6.453f, 13.873f, 6.49f)
            curveTo(13.919f, 6.527f, 13.983f, 6.514f, 13.965f, 6.405f)
            curveTo(13.928f, 6.064f, 13.772f, 6.015f, 13.754f, 5.857f)
            curveTo(13.845f, 5.869f, 13.91f, 5.869f, 13.946f, 5.821f)
            curveTo(13.974f, 5.772f, 14.01f, 5.687f, 14.047f, 5.663f)
            curveTo(14.075f, 5.638f, 14.075f, 5.614f, 14.038f, 5.626f)
            curveTo(13.992f, 5.638f, 13.965f, 5.663f, 13.882f, 5.65f)
            curveTo(13.687f, 5.622f, 13.735f, 4.699f, 13.09f, 4.52f)
            curveTo(12.691f, 4.409f, 12.193f, 5.17f, 12.057f, 5.245f)
            curveTo(12.054f, 5.246f, 12.051f, 5.248f, 12.049f, 5.249f)
            curveTo(11.984f, 5.249f, 11.929f, 5.212f, 11.893f, 5.151f)
            close()
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(9f)
                verticalLineToRelative(7f)
                horizontalLineToRelative(-9f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFF2E42A5))) {
                moveTo(0f, 0f)
                horizontalLineToRelative(9f)
                verticalLineToRelative(7f)
                horizontalLineToRelative(-9f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF7FCFF))) {
                moveTo(-1.002f, 6.5f)
                lineTo(0.978f, 7.369f)
                lineTo(9.045f, 0.944f)
                lineTo(10.09f, -0.346f)
                lineTo(7.972f, -0.637f)
                lineTo(4.682f, 2.132f)
                lineTo(2.033f, 3.997f)
                lineTo(-1.002f, 6.5f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF50100))) {
                moveTo(-0.731f, 7.108f)
                lineTo(0.278f, 7.613f)
                lineTo(9.715f, -0.466f)
                horizontalLineTo(8.298f)
                lineTo(-0.731f, 7.108f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF7FCFF))) {
                moveTo(10.002f, 6.5f)
                lineTo(8.022f, 7.369f)
                lineTo(-0.045f, 0.944f)
                lineTo(-1.09f, -0.346f)
                lineTo(1.028f, -0.637f)
                lineTo(4.318f, 2.132f)
                lineTo(6.967f, 3.997f)
                lineTo(10.002f, 6.5f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF50100))) {
                moveTo(9.935f, 6.937f)
                lineTo(8.926f, 7.441f)
                lineTo(4.907f, 3.982f)
                lineTo(3.716f, 3.595f)
                lineTo(-1.19f, -0.342f)
                horizontalLineTo(0.227f)
                lineTo(5.13f, 3.502f)
                lineTo(6.433f, 3.965f)
                lineTo(9.935f, 6.937f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF50100)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(4.992f, 0f)
                horizontalLineTo(3.992f)
                verticalLineTo(3f)
                horizontalLineTo(0f)
                verticalLineTo(4f)
                horizontalLineTo(3.992f)
                verticalLineTo(7f)
                horizontalLineTo(4.992f)
                verticalLineTo(4f)
                horizontalLineTo(9f)
                verticalLineTo(3f)
                horizontalLineTo(4.992f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(3.242f, -0.75f)
                horizontalLineTo(5.742f)
                verticalLineTo(2.25f)
                horizontalLineTo(9.75f)
                verticalLineTo(4.75f)
                horizontalLineTo(5.742f)
                verticalLineTo(7.75f)
                horizontalLineTo(3.242f)
                verticalLineTo(4.75f)
                horizontalLineTo(-0.75f)
                verticalLineTo(2.25f)
                horizontalLineTo(3.242f)
                verticalLineTo(-0.75f)
                close()
                moveTo(3.992f, 3f)
                horizontalLineTo(0f)
                verticalLineTo(4f)
                horizontalLineTo(3.992f)
                verticalLineTo(7f)
                horizontalLineTo(4.992f)
                verticalLineTo(4f)
                horizontalLineTo(9f)
                verticalLineTo(3f)
                horizontalLineTo(4.992f)
                verticalLineTo(0f)
                horizontalLineTo(3.992f)
                verticalLineTo(3f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun CaymanIslandsPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Small.CaymanIslands,
            contentDescription = "Cayman Islands Flag"
        )
    }
}
